export const HeartIcon = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="20" fill="#B7E801" />
      <path
        d="M39.3999 17.1665C36.3833 17.1665 33.6833 18.6332 31.9999 20.8832C30.3166 18.6332 27.6166 17.1665 24.5999 17.1665C19.4833 17.1665 15.3333 21.3332 15.3333 26.4832C15.3333 28.4665 15.6499 30.2998 16.1999 31.9998C18.8333 40.3332 26.9499 45.3165 30.9666 46.6832C31.5333 46.8832 32.4666 46.8832 33.0333 46.6832C37.0499 45.3165 45.1666 40.3332 47.7999 31.9998C48.3499 30.2998 48.6666 28.4665 48.6666 26.4832C48.6666 21.3332 44.5166 17.1665 39.3999 17.1665Z"
        fill="#4A25D5"
      />
    </svg>
  );
};
